import store_examen from '@/store/mods/consultations/consultations'

export default {
    name: 'historique-imagerie-medicale',
    components: {
        
    },
    props: {
        historique: Object,
        patient: Object
    },

    data() {
        return {
            demande_examen: {}
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        viewResult(demande_examen) {
            const data = {
                demande_id: demande_examen.examen_id,
            }

            store_examen.getHistoriqueResultatExamen(data).then((response) => {
                const info_resultat = {
                    patient: this.patient.nom+' '+this.patient.prenoms,
                    age: this.patient.age,
                    sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                    telephone: this.patient.telephone_mobile,
                    date_naissance: this.patient.date_naissance,
                    demande_id: demande_examen.examen_id,
                    etat_resultat: response.etat_resultat,
                    interpretation: response.interpretation,
                    nom_prescripteur: response.nom_prescripteur,
                    titre_prescripteur: response.titre_prescripteur,
                    nom_radiologue: response.nom_radiologue,
                    titre_radiologue: response.titre_radiologue,
                    renseignement_clinique: response.renseignement_clinique,
                    resultat: response.resultat,
                    tel_pers_a_prevenir: response.tel_pers_a_prevenir
                }

                const preview_data = {
                    type_examen_nom: demande_examen.type_examen_nom,
                    resultat: demande_examen.resultat,
                    interpretation: demande_examen.interpretation
                }

                const param_result = {
                    result_preview: preview_data,
                    evolution_id: this.historique.evolution_id,
                    info_resultat: info_resultat
                }
                this.$emit('emitViewResultImagerie', param_result)
                
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })

            
            
            // const param_result = {
            //     demande_examen: demande_examen,
            //     evolution_id: this.historique.evolution_id
            // }
            // this.$emit('emitViewResultImagerie', param_result)
        }
    }
}


